module.exports = __webpack_public_path__ + "static/media/carey-nachenberg.0fbeaea4.png";